import { useCallback } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Form } from "@/components/controls";
import {
  LicenseForm,
  useLicenseForm,
} from "@/components/profile-forms/LicenseForm";
import type { IInspectorLicense } from "@/types/users-inspectors";
import { Button, Drawer } from "@/ui-kit";

type IProps = {
  userId: number;
  license: IInspectorLicense;
  onSave: (v: IInspectorLicense) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, license, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorLicense) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading } = useLicenseForm({
    userId,
    license,
    onSuccess: handleSuccess,
  });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
      >
        <Drawer.Header title={t("label.license_details")} />
        <Drawer.Body>
          <Form>
            <LicenseForm />
          </Form>
        </Drawer.Body>
        <Drawer.Footer>
          <Button onClick={onDismiss} variant="ghost" color="neutral">
            {t("action.cancel")}
          </Button>
          <Button onClick={onSubmit} loading={loading}>
            {t("action.save")}
          </Button>
        </Drawer.Footer>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
